(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "lodash", "prop-types", "@fiverr/i18n/singleton", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["SeoSubCategory"] = factory(require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("react-dom"));
	else
		root["SeoSubCategory"] = factory(root["React"], root["_"], root["PropTypes"], root["i18n"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_PbPb__, __WEBPACK_EXTERNAL_MODULE_T9WB__, __WEBPACK_EXTERNAL_MODULE_h4G9__, __WEBPACK_EXTERNAL_MODULE_wLXD__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://npm-assets.fiverrcdn.com/assets/@fiverr/seo_sub_category/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "lVK7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "GP3H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IKh/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmof":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_Jmof__;

/***/ }),

/***/ "OqJi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PbPb":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_PbPb__;

/***/ }),

/***/ "T9WB":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_T9WB__;

/***/ }),

/***/ "eIBB":
/***/ (function(module, exports) {

module.exports = {"seo_sub_category":{"faqs":{"title":"%{sub_category_title} FAQs"},"relatedLinks":{"title":"Services Related To %{sub_category_title}"}}}

/***/ }),

/***/ "h4G9":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_h4G9__;

/***/ }),

/***/ "iCOP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React","var":"React"}
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__ = __webpack_require__("Jmof");
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__);

// EXTERNAL MODULE: external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom","root":"ReactDOM","var":"ReactDOM"}
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM__ = __webpack_require__("wLXD");
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM__);

// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types","root":"PropTypes","var":"PropTypes"}
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__ = __webpack_require__("T9WB");
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__);

// EXTERNAL MODULE: ./src/components/Faqs/style.scss
var style = __webpack_require__("GP3H");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/components/Faqs/index.js




var Faqs_Faqs = function Faqs(_ref) {
    var title = _ref.title,
        faqs = _ref.faqs;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'section',
        { className: 'faqs' },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'h2',
            null,
            i18n.t('seo_sub_category.faqs.title', { sub_category_title: title })
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'ul',
            null,
            faqs.map(function (content, index) {
                return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'li',
                    { key: index },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'h3',
                        null,
                        content.question
                    ),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'p',
                        null,
                        content.answer
                    )
                );
            })
        )
    );
};

Faqs_Faqs.propTypes = {
    title: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    faqs: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array
};

Faqs_Faqs.defaultProps = {
    title: '',
    faqs: []
};

/* harmony default export */ var components_Faqs = (Faqs_Faqs);
// EXTERNAL MODULE: ./src/components/RelatedLinks/RelatedLink/style.scss
var RelatedLink_style = __webpack_require__("IKh/");
var RelatedLink_style_default = /*#__PURE__*/__webpack_require__.n(RelatedLink_style);

// CONCATENATED MODULE: ./src/components/RelatedLinks/RelatedLink/propTypes.js


/* harmony default export */ var propTypes = ({
    openInNewTab: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    url: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired,
    text: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired
});
// CONCATENATED MODULE: ./src/components/RelatedLinks/RelatedLink/index.js




var RelatedLink_RelatedLink = function RelatedLink(_ref) {
    var openInNewTab = _ref.openInNewTab,
        url = _ref.url,
        text = _ref.text;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'a',
        { href: url, className: 'related-link', target: openInNewTab ? '_blank' : '' },
        text
    );
};

RelatedLink_RelatedLink.propTypes = propTypes;

RelatedLink_RelatedLink.defaultProps = {
    openInNewTab: false
};

/* harmony default export */ var RelatedLinks_RelatedLink = (RelatedLink_RelatedLink);
// EXTERNAL MODULE: ./src/components/RelatedLinks/style.scss
var RelatedLinks_style = __webpack_require__("OqJi");
var RelatedLinks_style_default = /*#__PURE__*/__webpack_require__.n(RelatedLinks_style);

// CONCATENATED MODULE: ./src/components/RelatedLinks/index.js






var RelatedLinks_RelatedLinks = function RelatedLinks(_ref) {
    var title = _ref.title,
        relatedLinks = _ref.relatedLinks;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'section',
        { className: 'related-links' },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'h2',
            null,
            i18n.t('seo_sub_category.relatedLinks.title', { sub_category_title: title })
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'ul',
            null,
            relatedLinks.map(function (link, idx) {
                return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'li',
                    { key: idx },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(RelatedLinks_RelatedLink, link)
                );
            })
        )
    );
};

RelatedLinks_RelatedLinks.propTypes = {
    relatedLinks: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.arrayOf(external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.shape(propTypes))
};

RelatedLinks_RelatedLinks.defaultProps = {
    relatedLinks: []
};

/* harmony default export */ var components_RelatedLinks = (RelatedLinks_RelatedLinks);
// EXTERNAL MODULE: ./src/translations.en.json
var translations_en = __webpack_require__("eIBB");
var translations_en_default = /*#__PURE__*/__webpack_require__.n(translations_en);

// EXTERNAL MODULE: external {"commonjs":"@fiverr/i18n/singleton","commonjs2":"@fiverr/i18n/singleton","amd":"@fiverr/i18n/singleton","root":"i18n","var":"i18n"}
var singleton___root___i18n___var___i18n__ = __webpack_require__("h4G9");
var singleton___root___i18n___var___i18n___default = /*#__PURE__*/__webpack_require__.n(singleton___root___i18n___var___i18n__);

// EXTERNAL MODULE: ./src/index.scss
var src = __webpack_require__("iCOP");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// EXTERNAL MODULE: external {"commonjs":"lodash","commonjs2":"lodash","amd":"lodash","root":"_","var":"_"}
var external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var______ = __webpack_require__("PbPb");
var external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default = /*#__PURE__*/__webpack_require__.n(external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var______);

// CONCATENATED MODULE: ./src/SeoSubCategory.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SeoSubCategory_SeoSubCategory = function (_PureComponent) {
    _inherits(SeoSubCategory, _PureComponent);

    function SeoSubCategory(props) {
        _classCallCheck(this, SeoSubCategory);

        var _this = _possibleConstructorReturn(this, (SeoSubCategory.__proto__ || Object.getPrototypeOf(SeoSubCategory)).call(this, props));

        i18n.add(translations_en_default.a);
        return _this;
    }

    _createClass(SeoSubCategory, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                faqs = _props.faqs,
                relatedLinks = _props.relatedLinks;


            if (external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default.a.isEmpty(faqs) && external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default.a.isEmpty(relatedLinks)) {
                return null;
            }

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'seo-sub-category' },
                !external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default.a.isEmpty(faqs) && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(components_Faqs, { title: title, faqs: faqs }),
                !external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default.a.isEmpty(relatedLinks) && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(components_RelatedLinks, { title: title, relatedLinks: relatedLinks })
            );
        }
    }]);

    return SeoSubCategory;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

SeoSubCategory_SeoSubCategory.propTypes = {
    title: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    faqs: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array,
    relatedLinks: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.arrayOf(external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.shape(propTypes))
};

SeoSubCategory_SeoSubCategory.defaultProps = {
    title: '',
    faqs: [],
    relatedLinks: []
};

/* harmony default export */ var src_SeoSubCategory = (SeoSubCategory_SeoSubCategory);
// CONCATENATED MODULE: ./src/index.js




var componentElm = typeof document !== 'undefined' && document.getElementById('SeoSubCategory-component');

if (componentElm) {
    var initialState = window.initialData.SeoSubCategory;

    external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM___default.a.render(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_SeoSubCategory, initialState), componentElm);
}

/* harmony default export */ var src_0 = __webpack_exports__["default"] = (src_SeoSubCategory);

/***/ }),

/***/ "wLXD":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_wLXD__;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index.141243eef0b1aa9eb89e.js